// One icon per sidebar destination, keyed by route. Inline SVG, like icons.js, so there
// is no icon font and no network request, and each inherits the nav item's colour.
//
// WORN ONLY BY THE NEW DESIGN FOR NOW. Layout renders the icon on every screen, but it is
// hidden unless <html> carries the `ds` class (styles/dsShell.css), so the sidebar of
// every other screen is unchanged until the design is rolled out.
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const P = {
  '/': ['M12 3v2', 'M12 19v2', 'M5 5l1.5 1.5', 'M17.5 17.5 19 19', 'M3 12h2', 'M19 12h2',
    'M5 19l1.5-1.5', 'M17.5 6.5 19 5', 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z'],
  '/board': ['M4 5h16v14H4z', 'M8 10l2 2 4-4', 'M8 16h8'],
  '/calendar': ['M4 6h16v14H4z', 'M4 10h16', 'M8 3v4', 'M16 3v4'],
  '/notes': ['M5 4h14v11l-5 5H5z', 'M14 20v-5h5'],
  '/clients': ['M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6',
    'M16 4.5a3.5 3.5 0 0 1 0 6.5', 'M18 14c1.8.8 3 2.7 3 5'],
  '/leads': ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M12 12h.01'],
  '/retainers': ['M4 12a8 8 0 0 1 13.7-5.6L20 8', 'M20 4v4h-4', 'M20 12a8 8 0 0 1-13.7 5.6L4 16', 'M4 20v-4h4'],
  '/jobs': ['M4 8h16v11H4z', 'M9 8V5h6v3', 'M4 13h16'],
  '/lists': ['M9 6h11', 'M9 12h11', 'M9 18h11', 'M4.5 6h.01', 'M4.5 12h.01', 'M4.5 18h.01'],
  '/money': ['M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z', 'M3 7l3-3h11v3', 'M16 13.5h.01'],
  '/settlements': ['M12 4v16', 'M5 8h14', 'M5 8l-3 6a3 3 0 0 0 6 0Z', 'M19 8l-3 6a3 3 0 0 0 6 0Z', 'M8 20h8'],
  '/dashboard': ['M4 20V10', 'M10 20V4', 'M16 20v-7', 'M22 20H2'],
  '/expenses': ['M6 3h12v18l-3-2-3 2-3-2-3 2Z', 'M9 8h6', 'M9 12h6'],
  '/documents': ['M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z'],
  '/client-documents': ['M8 3h8l4 4v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z', 'M16 3v4h4', 'M9 13h7', 'M9 17h5'],
  '/settings': ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    'M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14 3h-4l-.5 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6a7 7 0 0 0 0 2.4l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2L10 21h4l.5-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2Z'],
  '/users': ['M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M3 21c0-3.9 3.1-7 7-7 1.3 0 2.5.3 3.5.9',
    'M19 16v6', 'M16 19h6'],
};

export default function NavIcon({ to }) {
  const paths = P[to];
  if (!paths) return null;
  return (
    <span className="nav-icon">
      <svg {...base}>{paths.map((d) => <path key={d} d={d} />)}</svg>
    </span>
  );
}
